import React, { useState } from 'react';
import { FormControlLabel, Button, Box, Typography, TextField, MenuItem, Grid, FormControl, InputLabel, Select, Switch, Chip, Dialog, DialogActions, DialogTitle, DialogContent, useMediaQuery, useTheme, Link, Divider, FormHelperText, Paper } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import {
    useTranslate, useNotify
} from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import 'dayjs/locale/es'
import { CollectionsBookmarkRounded, ConnectingAirportsOutlined } from '@mui/icons-material';
import CurrencyInput from 'src/components/uiElements/fields/CurrencyInput'
import dayjs from 'dayjs';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function CustomDivider(content) {
    return (
        <Box display="flex" alignItems="center" sx={{ width: '98%', margin: '15px 0 auto 15px' }}>
            <Typography variant="body1" sx={{ mr: 2, color: '#a9afc8', fontWeight: 'bold' }}>
                {content}
            </Typography>
            <Divider sx={{ flexGrow: 1, borderBottomWidth: 2, borderColor: 'rgba(222,222,222,255)' }} />
        </Box>
    );
}

const pay_type = [
    'transferencia bancaria',
    'deposito bancario',
    'tarjeta de crédito',
    'paypal',
    'getnet',
    'efectivo',
    'cheque',
    'otras transferencias'
];

const TIPO_cHEQUE = [
    { "id": "comun", "description": "Común" },
    { "id": "diferido", "description": "Diferido" },
]

const RETENCIONES = [
    { "id": "IVA", "description": "IVA" },
    { "id": "Ganancias", "description": "Ganancias" },
    { "id": "SuSS", "description": "SuSS" },
    { "id": "IIBB", "description": "IIBB" },
    // { "id": "Otras", "description": "Otras" },
]

const CUOTAS_TC = [
    { "id": 1, "description": "1 cuota" },
    { "id": 2, "description": "2 cuotas" },
    { "id": 3, "description": "3 cuotas" },
    { "id": 4, "description": "4 cuotas" },
    { "id": 5, "description": "5 cuotas" },
    { "id": 6, "description": "6 cuotas" },
    { "id": 7, "description": "7 cuotas" },
    { "id": 8, "description": "8 cuotas" },
    { "id": 9, "description": "9 cuotas" }
]

const fieldsToClear = [
    'bank_info', 'document_number', 'customer_name', 'card_info', 'card_number',
    'expiry_date', 'quota', 'coupon_number', 'auth_code', 'payment_date',
    'payment_id', 'amount', 'cash_info', 'currency_info', 'check_type', 'date_emision'
];

const initialPaymentDataForm = {
    payment_type: '',
    bank_info: '',
    document_number: '',
    customer_name: '',
    card_info: '',
    card_number: '',
    expiry_date: '',
    quota: '',
    coupon_number: '',
    auth_code: '',
    payment_date: '',
    payment_id: '',
    amount: '',
    cash_info: '',
    currency_info: '',
    check_type: '',
    date_emision: '',
    retentions: [], // Inicializa un array vacío de retenciones
}


function PaymentModal({
    open,
    handleClose,
    handleSavePayment,
    paymentTypes,
    banks,
    cards,
    currencies,
    cash,
    disabledDate
}) {
    const translate = useTranslate()
    const [paymentDataForm, setPaymentDataForm] = useState(initialPaymentDataForm);
    const [retentionFiles, setRetentionFiles] = useState([]);
    const [errors, setErrors] = useState({});
    const [fileLimit, setFileLimit] = useState(false)
    const notify = useNotify()
    const [paymentNotRegistered, setPaymentNotRegistered] = useState(false)

    const theme = useTheme(); // Obtener el tema actual
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm')); // Determinar si es pantalla pequeña

    const onChangeField = (field, value, index = null) => {
        const dataFormAux = { ...paymentDataForm };
        const errorsAux = {}

        if (field === 'payment_type') {
            fieldsToClear.forEach((f) => {
                dataFormAux[f] = '';   // Limpia los datos
                errorsAux[f] = '';     // Limpia los errores
            });
            dataFormAux['retentions'] = []

            if (value && !pay_type.some(type => type.toLowerCase() === getLongNameById(value)?.toLowerCase())) {
                setPaymentNotRegistered(true);
            } else {
                setPaymentNotRegistered(false);
            }
        }
        if (index !== null && field.startsWith('retention_')) {
            const newFieldName = field.replace('retention_', '');
            dataFormAux.retentions[index][newFieldName] = value;
        } else if (field === 'bank_info') {
            dataFormAux['bank_info'] = {
                id: value.id,
                name: value.name,
                code: value.code,
            }
        } else if (field === 'card_info') {
            dataFormAux['card_info'] = {
                id: value.id,
                long_name: value.long_name,
                slug: value.slug
            }
        } else if (field === 'cash_info') {
            dataFormAux['cash_info'] = {
                id: value.id,
                name: value.name,
                code: value.code
            }
        } else if (field === 'currency_info') {
            dataFormAux['currency_info'] = {
                id: value.id,
                short_name: value.short_name,
                hash_currency: value.hash_currency
            }
        } else if (field === 'check_type') {
            dataFormAux['check_type'] = value;
            dataFormAux['date_emision'] = null;
        }
        else {
            dataFormAux[field] = value;
        }

        setPaymentDataForm(dataFormAux);
        setErrors(errorsAux);
    };

    const addNewRetention = () => {
        setPaymentDataForm((prevState) => ({
            ...prevState,
            retentions: [...prevState.retentions, { type: '', amount: '', certificate: '', files: [] }],
        }));

        // Limpia los errores de las retenciones
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            Object.keys(newErrors).forEach((key) => {
                if (key.startsWith('retention_')) {
                    delete newErrors[key];
                }
            });
            return newErrors;
        });
    };

    const removeRetention = (indexToRemove) => {
        const updatedRetentions = paymentDataForm.retentions.filter((_, index) => index !== indexToRemove);
        const updatedErrors = { ...errors };

        // Eliminar los errores asociados a la retención eliminada
        delete updatedErrors[`retention_type_${indexToRemove}`];
        delete updatedErrors[`retention_amount_${indexToRemove}`];
        delete updatedErrors[`retention_certificate_${indexToRemove}`];
        delete updatedErrors[`retention_files_${indexToRemove}`];

        setPaymentDataForm({ ...paymentDataForm, retentions: updatedRetentions });
        setErrors(updatedErrors); // Actualizar errores sin los de la retención eliminada
    };

    const validateRetentions = () => {
        const errorsAux = {}; // Objeto para almacenar los errores de cada campo
        let isValid = true;

        paymentDataForm.retentions.forEach((retention, index) => {
            if (!retention.type) {
                errorsAux[`retention_type_${index}`] = true;
                isValid = false;
            }
            if (!retention.amount) {
                errorsAux[`retention_amount_${index}`] = true;
                isValid = false;
            }
            if (!retention.certificate) {
                errorsAux[`retention_certificate_${index}`] = true;
                isValid = false;
            }
            if (retention.files.length === 0) {
                errorsAux[`retention_files_${index}`] = true;
                isValid = false;
            }
        });

        setErrors(errorsAux); // Actualiza los errores en el estado
        return isValid;
    };

    const onSave = () => {
        const errorsAux = {};
        const paymentType = getLongNameById(paymentDataForm['payment_type']).toLowerCase();

        if (!validateRetentions()) {
            return;
        }

        if (!paymentDataForm['payment_type'] || paymentDataForm['payment_type'] === '') {
            errorsAux['payment_type'] = true;
        }

        if (!paymentDataForm['payment_date'] && !disabledDate) {
            errorsAux['payment_date'] = true;
        }
        if (paymentDataForm['payment_date']) {
            const today = dayjs().endOf('day'); // Límite: fin del día actual
            if (dayjs(paymentDataForm['payment_date']).isAfter(today)) {
                errorsAux['payment_date'] = true
            }
        }
        if (paymentType === 'tarjeta de crédito' && (!paymentDataForm['card_number'] || paymentDataForm['card_number'].length !== 4)) {
            errorsAux['card_number'] = true;
        }
        if (paymentType === 'tarjeta de crédito' && (!paymentDataForm['auth_code'] || paymentDataForm['auth_code'].length > 10 || paymentDataForm['auth_code'].length < 1)) {
            errorsAux['auth_code'] = true;
        }
        if (paymentType === 'tarjeta de crédito' && (paymentDataForm['quota'] == '0' || paymentDataForm['quota'] == '00')) {
            errorsAux['quota'] = true;
        }
        if (
            (paymentType === 'transferencia bancaria' || paymentType === 'cheque' || paymentType === 'otras transferencias') &&
            paymentDataForm['document_number'] !== '' &&
            (paymentDataForm['document_number'].length !== 11)
        ) {
            errorsAux['document_number'] = true;
        }
        if ((paymentType === 'tarjeta de crédito' || paymentType === 'deposito bancario' || paymentType === 'cheque' || paymentType === 'otras transferencias') && (!paymentDataForm['coupon_number'] || paymentDataForm['coupon_number'].length > 10 || paymentDataForm['coupon_number'].length < 1)) {
            errorsAux['coupon_number'] = true;
        }
        if ((paymentType === 'paypal' || paymentType === 'getnet') && (!paymentDataForm['payment_id'] || paymentDataForm['payment_id'].length > 10 || paymentDataForm['payment_id'].length < 1)) {
            errorsAux['payment_id'] = true;
        }

        let payment = {
            amount: parseFloat(paymentDataForm['amount'].replace(/\./g, '').replace(',', '.')),
            payment_date: disabledDate || paymentDataForm['payment_date'],
            currency_info: paymentDataForm['currency_info'],
            payment_type: paymentType,
            payment_method_id: paymentDataForm['payment_type'],
            files: [],
            retentions: paymentDataForm['retentions'] || [],
        };

        const validateFields = (fields) => {
            fields.forEach((field) => {
                if (paymentDataForm[field] === null || paymentDataForm[field] === '') {
                    errorsAux[field] = true;
                }
            });
        };

        switch (paymentType) {
            case 'transferencia bancaria':
                validateFields(['bank_info', 'currency_info', 'amount']);
                if (Object.keys(errorsAux).length === 0) {
                    payment.bank_info = {
                        ...paymentDataForm['bank_info'],
                        document_number: paymentDataForm['document_number'],
                        coupon_number: paymentDataForm['coupon_number']
                    };
                }
                break;
            case 'otras transferencias':
                validateFields(['currency_info', 'amount', 'bank_info']);
                payment.bank_info = {
                        ...paymentDataForm['bank_info'],
                        document_number: paymentDataForm['document_number'],
                        coupon_number: paymentDataForm['coupon_number']
                    };
                break;
            case 'deposito bancario':
                validateFields(['bank_info', 'coupon_number', 'currency_info', 'amount']);
                if (Object.keys(errorsAux).length === 0) {
                    payment.bank_info = {
                        ...paymentDataForm['bank_info'],
                        coupon_number: paymentDataForm['coupon_number']
                    };
                }
                break;
            case 'tarjeta de crédito':
                validateFields([
                    'customer_name', 'card_info', 'card_number', 'expiry_date',
                    'quota', 'coupon_number', 'auth_code',
                    'currency_info', 'amount'
                ]);
                if (Object.keys(errorsAux).length === 0) {
                    payment.card_info = {
                        auth_code: paymentDataForm['auth_code'],
                        card_number: paymentDataForm['card_number'],
                        coupon_code: paymentDataForm['coupon_number'],
                        customer_name: paymentDataForm['customer_name'],
                        expiry_date: paymentDataForm['expiry_date'],
                        quotes: paymentDataForm['quota'],
                        long_name: paymentDataForm['card_info']?.long_name,
                        id: paymentDataForm['card_info']?.id,
                        slug: paymentDataForm['card_info']?.slug
                    };
                }
                break;
            case 'paypal':
                validateFields(['payment_id', 'currency_info', 'amount']);
                if (Object.keys(errorsAux).length === 0) {
                    payment.wallet_info = {
                        name: 'paypal',
                        payment_id: paymentDataForm['payment_id']
                    };
                }
                break;
            case 'getnet':
                validateFields(['payment_id', 'currency_info', 'amount']);
                if (Object.keys(errorsAux).length === 0) {
                    payment.wallet_info = {
                        name: 'getnet',
                        payment_id: paymentDataForm['payment_id']
                    };
                }
                break;
            case 'efectivo':
                validateFields(['cash_info', 'customer_name', 'currency_info', 'amount']);
                if (Object.keys(errorsAux).length === 0) {
                    payment.cash_info = {
                        code: paymentDataForm['cash_info']?.code,
                        customer_name: paymentDataForm['customer_name'],
                        name: paymentDataForm['cash_info']?.name,
                        id: paymentDataForm['cash_info']?.id
                    };
                }
                break;
            case 'cheque':
                validateFields([
                    'coupon_number', 'bank_info', 'check_type', 'customer_name',
                    'currency_info', 'amount'
                ]);
                //por lo pronto comentamos la obligatoriedad de document_number
                // Validación de `date_emision` si `check_type` es "diferido"
                if (paymentDataForm['check_type'] === 'diferido') {
                    if (!paymentDataForm['date_emision']) {
                        errorsAux['date_emision'] = true;
                    } else {
                        const today = dayjs().endOf('day'); // Límite: fin del día actual
                        if (dayjs(paymentDataForm['date_emision']).isAfter(today)) {
                            errorsAux['date_emision'] = true
                        }
                    }
                }

                if (Object.keys(errorsAux).length === 0) {
                    payment.check_info = {
                        bank_name: paymentDataForm['bank_info']?.name,
                        coupon_number: paymentDataForm['coupon_number'],
                        customer_name: paymentDataForm['customer_name'],
                        document_number: paymentDataForm['document_number'],
                        type: paymentDataForm['check_type'],
                        date_emision: paymentDataForm['date_emision'] || null,
                    };
                }
                break;
            default:
                break;
        }

        setErrors(errorsAux);

        if (Object.keys(errorsAux).length === 0) {
            const payments = payment; // Estructura completa de pagos
            handleSavePayment(payments); // Guardar los datos del formulario
            handleModalClose();
        }
    };

    const getLongNameById = (id) => {
        if (!Array.isArray(paymentTypes)) {
            return null; // O un valor por defecto que necesites
        }
        const method = paymentTypes.find(method => method.id === id);
        return method ? method.long_name.toLowerCase() : null;
    };

    const selectedLongName = () => {
        const paymentType = paymentDataForm.payment_type;
        return getLongNameById(paymentType);
    };

    const handleFileChange = (e, index) => {
        const newFiles = Array.from(e.target.files);
        const updatedRetentions = [...paymentDataForm.retentions];

        if (!updatedRetentions[index].files) {
            updatedRetentions[index].files = [];
        }

        updatedRetentions[index].files = [
            ...updatedRetentions[index].files,
            ...newFiles
        ];

        setPaymentDataForm((prevForm) => ({
            ...prevForm,
            retentions: updatedRetentions
        }));

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[`retention_files_${index}`];  // Elimina el error relacionado con este índice
            return newErrors;
        });
    };

    const deleteFile = (fileName, retentionIndex) => {
        const updatedRetentions = [...paymentDataForm.retentions];
        updatedRetentions[retentionIndex].files = updatedRetentions[retentionIndex].files.filter(file => file.name !== fileName);

        setPaymentDataForm((prevForm) => ({
            ...prevForm,
            retentions: updatedRetentions
        }));
    };

    const resetForm = () => {
        setPaymentDataForm(initialPaymentDataForm)
        setPaymentNotRegistered(false)
    };

    const handleModalClose = () => {
        resetForm(); // Limpiar los inputs y archivos
        handleClose(); // Cerrar el modal
    };

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    { handleModalClose() }
                }
            }}
            fullWidth
            maxWidth="md" // Limita el tamaño máximo en pantallas grandes
            fullScreen={fullScreen} // Pantalla completa en móviles
            disableEscapeKeyDown
        >
            {/* HEADER */}
            <DialogTitle id="modal-title" sx={{ textAlign: 'center' }}>
                {translate('ra.title.paymentRecord')}
            </DialogTitle>

            <DialogContent >
                {/* Contenido del modal */}
                <Grid container spacing={2}>
                    <Grid container item md={12} lg={12} xs={12} className='payment-register-payment'>
                        <>
                            <EditInputsWrap label={`${translate('ra.field.payment_type')}*`} md={4} lg={4} xs={12} >
                                <FormControl fullWidth variant="outlined" size="small" error={!!errors['payment_type']}>
                                    <InputLabel></InputLabel>
                                    <Select
                                        value={paymentDataForm.payment_type || ''}
                                        onChange={e => onChangeField('payment_type', e.target.value)}
                                        displayEmpty
                                    >
                                        {paymentTypes.map(option => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.long_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>{!!errors['payment_type'] ? "El campo el obligatorio" : ""}</FormHelperText>
                                    <FormHelperText></FormHelperText>
                                </FormControl>

                            </EditInputsWrap>
                            {paymentNotRegistered ? (
                                <>
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Paper
                                            sx={{
                                                padding: '15px',
                                                border: '1px solid rgb(174, 180, 203)',
                                                borderRadius: '8px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '10px',
                                                margin: '25px 15px',
                                            }}
                                        >
                                            <Grid container spacing={1}>
                                                <InfoOutlinedIcon fontSize="small" />
                                                <Typography variant="body1"> &nbsp; {translate('ra.message.paymentMethodNotConfigured')} </Typography>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                </>
                            ) :
                                (
                                    <>
                                        {['transferencia bancaria', 'deposito bancario', 'cheque', 'otras transferencias'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate(
                                                    ['transferencia bancaria', 'deposito bancario', 'otras transferencias'].includes(selectedLongName())
                                                        ? 'ra.field.destinationBank'
                                                        : 'ra.field.issuingBank'
                                                )}*`} md={4} lg={4} xs={12}>
                                                    <FormControl fullWidth variant="outlined" size="small" error={!!errors['bank_info']}>
                                                        <InputLabel></InputLabel>
                                                        <Select
                                                            value={paymentDataForm.bank_info.id || ''}
                                                            onChange={e => onChangeField('bank_info', banks.find(option => option.id === e.target.value))}
                                                            displayEmpty
                                                        >
                                                            {banks.map(option => (
                                                                <MenuItem key={option.id} value={option.id}>
                                                                    {option.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText>{!!errors['bank_info'] ? "El campo el obligatorio" : ""}</FormHelperText>
                                                    </FormControl>
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['cheque'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.check_type')}*`} md={4} lg={4} xs={12}>
                                                    <FormControl fullWidth variant="outlined" size="small" error={!!errors['check_type']}>
                                                        <InputLabel></InputLabel>
                                                        <Select
                                                            value={paymentDataForm.check_type || ''}
                                                            onChange={e => onChangeField('check_type', e.target.value)}
                                                            displayEmpty
                                                        >
                                                            {TIPO_cHEQUE.map(option => (
                                                                <MenuItem key={option.id} value={option.id}>
                                                                    {option.description}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText>{!!errors['check_type'] ? "El campo el obligatorio" : ""}</FormHelperText>
                                                    </FormControl>
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['cheque'].includes(selectedLongName()) && paymentDataForm?.check_type === 'diferido' && (
                                            <EditInputsWrap label={`${translate('ra.field.date_emision')}*`} md={4} lg={4} xs={12} >
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                                                    <DatePicker
                                                        disableFuture={true}
                                                        value={paymentDataForm.date_emision || null}
                                                        onChange={(date) => onChangeField('date_emision', date)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                variant="outlined"
                                                                size="small"
                                                                error={!!errors['date_emision']}
                                                            />
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </EditInputsWrap>
                                        )}
                                        {['transferencia bancaria', 'cheque', 'otras transferencias'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={translate('ra.field.payer_CUITCUIL')}>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                        inputMode="numeric"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            // Permitir solo hasta 4 dígitos numéricos
                                                            if (/^\d{0,11}$/.test(value)) {
                                                                onChangeField('document_number', value);
                                                            }
                                                        }}
                                                        value={paymentDataForm.document_number || ''}
                                                        error={!!errors['document_number']}
                                                        helperText={!!errors['document_number'] ? "Debe ingresar 11 dígitos numéricos" : ""}
                                                    />
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['efectivo'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.entity.cash')}*`} md={4} lg={4} xs={12}>
                                                    <FormControl fullWidth variant="outlined" size="small" error={!!errors['cash_info']}>
                                                        <InputLabel></InputLabel>
                                                        <Select
                                                            value={paymentDataForm.cash_info.id || ''}
                                                            onChange={e => onChangeField('cash_info', cash.find(option => option.id === e.target.value))}
                                                            displayEmpty
                                                        >
                                                            {cash.map(option => (
                                                                <MenuItem key={option.id} value={option.id}>
                                                                    {option.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText>{!!errors['cash_info'] ? "El campo el obligatorio" : ""}</FormHelperText>
                                                    </FormControl>
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['tarjeta de crédito', 'efectivo', 'cheque'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.customer_name')}*`} md={4} lg={4} xs={12} >
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => onChangeField('customer_name', e.target.value)}
                                                        value={paymentDataForm.customer_name || ''}
                                                        error={!!errors['customer_name']}
                                                    />
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['tarjeta de crédito'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.card')}*`} md={4} lg={4} xs={12} >
                                                    <FormControl fullWidth variant="outlined" size="small" error={!!errors['card_info']}>
                                                        <InputLabel ></InputLabel>
                                                        <Select
                                                            value={paymentDataForm.card_info.id || ''}
                                                            onChange={e => onChangeField('card_info', cards.find(option => option.id === e.target.value))}
                                                            displayEmpty
                                                        >
                                                            {cards.map(option => (
                                                                <MenuItem key={option.id} value={option.id}>
                                                                    {option.long_name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText>{!!errors['card_info'] ? "El campo el obligatorio" : ""}</FormHelperText>
                                                    </FormControl>
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['tarjeta de crédito'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.last_digit_card')}*`} md={4} lg={4} xs={12} >
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                        inputMode="numeric"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            // Permitir solo hasta 4 dígitos numéricos
                                                            if (/^\d{0,4}$/.test(value)) {
                                                                onChangeField('card_number', value);
                                                            }
                                                        }}
                                                        value={paymentDataForm.card_number || ''}
                                                        error={!!errors['card_number']}
                                                        helperText={!!errors['card_number'] ? "Debe ingresar 4 dígitos numéricos" : ""}
                                                    />
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['tarjeta de crédito'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.expiry_date')}*`} md={4} lg={4} xs={12} >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                                                        <DatePicker
                                                            disablePast={true}
                                                            minDate={dayjs().startOf('month')}
                                                            views={['year', 'month']} // Permite seleccionar solo año y mes
                                                            openTo="month" // Abre la vista en el selector de meses
                                                            value={paymentDataForm.expiry_date || null}
                                                            onChange={(date) => onChangeField('expiry_date', date)}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="small"
                                                                    error={!!errors['expiry_date']} // Aquí se establece el error
                                                                    onKeyDown={(e) => e.preventDefault()}
                                                                    InputProps={{ ...params.InputProps, readOnly: true }}
                                                                />
                                                            )}

                                                        />
                                                    </LocalizationProvider>
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {/* {['tarjeta de crédito'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.quota')}*`} md={4} lg={4} xs={12} >
                                                    <FormControl fullWidth variant="outlined" size="small" error={!!errors['quota']}>
                                                        <InputLabel ></InputLabel>
                                                        <Select

                                                            value={paymentDataForm.quota || ''}
                                                            onChange={e => onChangeField('quota', e.target.value)}
                                                            displayEmpty
                                                        >
                                                            {CUOTAS_TC.map(option => (
                                                                <MenuItem key={option.id} value={option.id}>
                                                                    {option.description}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText>{!!errors['quota'] ? "El campo el obligatorio" : ""}</FormHelperText>
                                                    </FormControl>
                                                </EditInputsWrap>
                                            </>
                                        )} */}
                                        {['tarjeta de crédito'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.quota')}*`} md={4} lg={4} xs={12} >
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                        inputMode="numeric"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            // Permitir solo hasta 4 dígitos numéricos
                                                            if (/^\d{0,2}$/.test(value)) {
                                                                onChangeField('quota', value);
                                                            }
                                                        }}
                                                        value={paymentDataForm.quota || ''}
                                                        error={!!errors['quota']}
                                                        helperText={!!errors['quota'] ? "Debe ingresar dígitos numéricos mayores a 0" : ""}
                                                    />
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['tarjeta de crédito', 'deposito bancario', 'cheque', 'otras transferencias'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.coupon_number')}*`} md={4} lg={4} xs={12} >
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                        inputMode={['tarjeta de crédito', 'cheque'].includes(selectedLongName()) ? 'numeric' : 'text'}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const isDeposit = selectedLongName() === 'deposito bancario';
                                                            const isCardOrCheque = ['tarjeta de crédito', 'cheque', 'otras transferencias'].includes(selectedLongName());
                                                            const regex = isDeposit ? /^[a-zA-Z0-9]{0,10}$/ : isCardOrCheque ? /^[0-9]{0,10}$/ : /^$/;
                                                            if (regex.test(value)) {
                                                                onChangeField('coupon_number', value);
                                                            }
                                                        }}
                                                        value={paymentDataForm.coupon_number || ''}
                                                        error={!!errors['coupon_number']}
                                                        helperText={!!errors['coupon_number']
                                                            ? `Debe ingresar 1 y 10 dígitos ${['tarjeta de crédito', 'cheque'].includes(selectedLongName()) ? 'numéricos' : ''}`
                                                            : ''}
                                                    />
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['tarjeta de crédito'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.auth_code')}*`} md={4} lg={4} xs={12} >
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^[a-zA-Z0-9]{0,10}$/.test(value)) {
                                                                onChangeField('auth_code', value);
                                                            }
                                                        }}
                                                        value={paymentDataForm.auth_code || ''}
                                                        error={!!errors['auth_code']}
                                                        helperText={!!errors['auth_code'] ? "Debe ingresar 1 y 10 dígitos" : ""}
                                                    />
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['tarjeta de crédito', 'transferencia bancaria', 'deposito bancario', 'getnet', 'paypal', 'efectivo', 'cheque', 'otras transferencias'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.payment_date')}*`} md={4} lg={4} xs={12} >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                                                        <DatePicker
                                                            disableFuture={true}
                                                            value={disabledDate ? disabledDate : paymentDataForm.payment_date || null}
                                                            onChange={(date) => onChangeField('payment_date', date)}
                                                            disabled={!!disabledDate}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    size="small"
                                                                    error={!!errors['payment_date']}
                                                                    disabled={!!disabledDate}
                                                                    helperText={
                                                                        errors['payment_date'] ? "La fecha no puede ser posterior a hoy" : ""
                                                                    }
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['getnet', 'paypal'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.payment_id')}*`} md={4} lg={4} xs={12} >
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        type="text"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^[a-zA-Z0-9]{0,10}$/.test(value)) {
                                                                onChangeField('payment_id', value);
                                                            }
                                                        }}
                                                        value={paymentDataForm.payment_id || ''}
                                                        error={!!errors['payment_id']}
                                                        helperText={!!errors['payment_id'] ? "Debe ingresar 1 y 10 dígitos" : ""}
                                                    />
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['tarjeta de crédito', 'transferencia bancaria', 'deposito bancario', 'getnet', 'paypal', 'efectivo', 'cheque', 'otras transferencias'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.currency')}*`} md={4} lg={4} xs={12} >
                                                    <FormControl fullWidth variant="outlined" size="small" error={!!errors['currency_info']}>
                                                        <InputLabel ></InputLabel>
                                                        <Select
                                                            value={paymentDataForm.currency_info.id || ''}
                                                            onChange={e => onChangeField('currency_info', currencies.find(option => option.id === e.target.value))}
                                                            displayEmpty
                                                        >
                                                            {currencies.map(option => (
                                                                <MenuItem key={option.id} value={option.id}>
                                                                    {option.long_name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText>{!!errors['currency_info'] ? "El campo el obligatorio" : ""}</FormHelperText>
                                                    </FormControl>
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {['tarjeta de crédito', 'transferencia bancaria', 'deposito bancario', 'getnet', 'paypal', 'efectivo', 'cheque', 'otras transferencias'].includes(selectedLongName()) && (
                                            <>
                                                <EditInputsWrap label={`${translate('ra.field.amount')}*`} md={4} lg={4} xs={12} >
                                                    <CurrencyInput
                                                        placeholder="0,00"
                                                        type="text"
                                                        onChange={(e) => onChangeField('amount', e.target.value)}
                                                        value={paymentDataForm.amount || ''}
                                                        error={!!errors['amount']}
                                                    />
                                                </EditInputsWrap>
                                            </>
                                        )}
                                        {paymentDataForm.payment_type !== '' &&
                                            <Grid item md={12} lg={12} xs={12}>
                                                {CustomDivider(translate('ra.field.retentions'))}
                                                <Box sx={{ padding: '5px 16px' }}>
                                                    {paymentDataForm.retentions.map((retention, index) => (
                                                        <Box key={index} sx={{ marginBottom: '15px' }}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} md={12}>
                                                                    <Box
                                                                        sx={{
                                                                            border: '2px dashed rgba(182, 183, 184, 0.5)',
                                                                            borderRadius: '8px',
                                                                            padding: '16px',
                                                                            boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.1)',
                                                                        }}
                                                                    >
                                                                        <Grid container spacing={2}>
                                                                            <EditInputsWrap label={`${translate('ra.field.retention_type')}*`} md={4} lg={4} xs={12}>
                                                                                <FormControl fullWidth variant="outlined" size="small" error={!!errors[`retention_type_${index}`]}>
                                                                                    <InputLabel></InputLabel>
                                                                                    <Select
                                                                                        value={retention.type}
                                                                                        onChange={(e) => onChangeField('retention_type', e.target.value, index)}
                                                                                        displayEmpty
                                                                                    >
                                                                                        {RETENCIONES.map(option => (
                                                                                            <MenuItem key={option.id} value={option.id}>
                                                                                                {option.description}
                                                                                            </MenuItem>
                                                                                        ))}
                                                                                    </Select>
                                                                                    <FormHelperText>{!!errors[`retention_type_${index}`] ? "El campo el obligatorio" : ""}</FormHelperText>
                                                                                </FormControl>
                                                                            </EditInputsWrap>

                                                                            <EditInputsWrap label={`${translate('ra.field.retention_amount')}*`} md={4} lg={4} xs={12}>
                                                                                <CurrencyInput
                                                                                    placeholder="0,00"
                                                                                    type="text"
                                                                                    onChange={(e) => onChangeField('retention_amount', e.target.value, index)}
                                                                                    value={retention.amount}
                                                                                    error={!!errors[`retention_amount_${index}`]}
                                                                                    showAdornment={true} // Muestra el adornment "ARS"
                                                                                    currencySymbol="ARS"
                                                                                />
                                                                            </EditInputsWrap>

                                                                            <EditInputsWrap label={`${translate('ra.field.retention_certificate')}*`} md={4} lg={4} xs={12}>
                                                                                <TextField
                                                                                    fullWidth
                                                                                    variant="outlined"
                                                                                    size="small"
                                                                                    value={retention.certificate}
                                                                                    onChange={(e) => onChangeField('retention_certificate', e.target.value, index)}
                                                                                    error={!!errors[`retention_certificate_${index}`]}
                                                                                />
                                                                            </EditInputsWrap>

                                                                            <Grid item xs={12} md={4}>
                                                                                <Button
                                                                                    variant="outlined"
                                                                                    size="medium"
                                                                                    startIcon={<UploadFileIcon />}
                                                                                    component="label"
                                                                                    sx={{
                                                                                        padding: '10px 20px',
                                                                                        borderRadius: '8px',
                                                                                    }}
                                                                                >
                                                                                    {translate('ra.action.add_file')}
                                                                                    <input
                                                                                        type="file"
                                                                                        hidden
                                                                                        accept=".png, .jpg, .jpeg, application/pdf"
                                                                                        multiple
                                                                                        onChange={(e) => handleFileChange(e, index)}
                                                                                    />
                                                                                </Button>
                                                                                {errors[`retention_files_${index}`] && (
                                                                                    <Typography variant="body2" color="error" sx={{ marginTop: '4px' }}>
                                                                                        Debes cargar al menos un archivo.
                                                                                    </Typography>
                                                                                )}
                                                                            </Grid>

                                                                            <Grid item xs={12} md={8}>
                                                                                <Box
                                                                                    sx={{
                                                                                        display: 'flex',
                                                                                        flexWrap: 'wrap',
                                                                                        padding: '8px',
                                                                                        border: '1px solid #e0e0e0',
                                                                                        borderRadius: '8px',
                                                                                        gap: '8px',
                                                                                        minHeight: '60px',
                                                                                    }}
                                                                                >
                                                                                    {retention.files.length > 0 ? (
                                                                                        retention.files.map((file, fileIndex) => (
                                                                                            <Chip
                                                                                                key={fileIndex}
                                                                                                label={file.name}
                                                                                                onDelete={() => deleteFile(file.name, index)}
                                                                                                variant="outlined"
                                                                                                sx={{
                                                                                                    backgroundColor: '#f5f5f5',
                                                                                                    border: '1px solid #ccc',
                                                                                                    padding: '8px',
                                                                                                    fontSize: '14px',
                                                                                                    '& .MuiChip-deleteIcon': {
                                                                                                        color: '#ff6b6b',
                                                                                                    },
                                                                                                }}
                                                                                            />
                                                                                        ))
                                                                                    ) : (
                                                                                        <Typography variant="body2" sx={{ color: '#999' }}>
                                                                                            {translate('ra.message.noFilesUploaded')}
                                                                                        </Typography>
                                                                                    )}
                                                                                </Box>
                                                                            </Grid>
                                                                            {index === paymentDataForm.retentions.length - 1 && (
                                                                                <Grid item xs={12} sx={{ textAlign: 'right' }}>
                                                                                    <Link
                                                                                        component="button"
                                                                                        variant="body2"
                                                                                        onClick={() => removeRetention(index)}
                                                                                        sx={{ cursor: 'pointer', color: '#ff6b6b' }}
                                                                                    >
                                                                                        {translate('ra.action.removeRetention')}
                                                                                    </Link>
                                                                                </Grid>
                                                                            )}
                                                                        </Grid>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    ))}

                                                    <Button
                                                        variant="outlined"
                                                        size="medium"
                                                        onClick={addNewRetention}
                                                        sx={{ marginTop: '16px' }}
                                                    >
                                                        {translate('ra.action.addNewRetention')}
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        }
                                    </>
                                )
                            }



                        </>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleModalClose}
                    sx={{
                        color: '#fff',
                        backgroundColor: '#d9534f', // Un rojo más suave que combine con #a9afc8
                        fontWeight: 'bold',
                        borderRadius: '8px',
                        padding: '8px 24px',
                        '&:hover': {
                            backgroundColor: '#c9302c', // Un poco más oscuro en hover
                        },
                    }}
                >
                    {translate('ra.action.cancel')}
                </Button>

                <Button
                    onClick={onSave}
                    disabled={paymentNotRegistered}
                    sx={{
                        color: '#fff',
                        backgroundColor: '#8a99d6', // Color principal de la combinación
                        fontWeight: 'bold',
                        borderRadius: '8px',
                        padding: '8px 24px',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Sombra para darle un toque elegante
                        '&:hover': {
                            backgroundColor: '#717fb8', // Un poco más oscuro en hover para resaltar la interacción
                        },
                    }}
                >
                    {translate('ra.action.save')}
                </Button>
            </DialogActions>

        </Dialog>
    );
}

export default PaymentModal;
